/**
 * Libellés statut RDV pour le bandeau détail Admin (UX commerçant).
 * Ne modifie pas les transitions métier — affichage uniquement.
 */

const RDV_STATUS_UX_LABELS = {
  EN_ATTENTE: 'En attente de confirmation',
  CONFIRME: 'Rendez-vous confirmé',
  ANNULE: 'Rendez-vous annulé',
  TERMINE: 'Rendez-vous terminé',
  ABSENT: 'Client absent',
}

/**
 * @param {object} commande
 * @param {{ label?: string, color?: string, icon?: import('react').ReactNode }} statusDisplay — getStatusDisplay existant
 */
export function getRdvDetailStatusUx(commande, statusDisplay = {}) {
  const paymentStatus = String(
    commande?.paymentQuote?.paymentStatus || commande?.paymentStatus || '',
  ).toUpperCase()

  if (paymentStatus === 'AWAITING_PAYMENT') {
    return {
      label: 'Paiement en attente',
      color: statusDisplay.color || 'bg-amber-100 text-amber-900',
      icon: statusDisplay.icon,
    }
  }

  const statut = String(commande?.statut || '').toUpperCase()
  const uxLabel = RDV_STATUS_UX_LABELS[statut]

  return {
    label: uxLabel || statusDisplay.label || statut || '—',
    color: statusDisplay.color || 'bg-gray-100 text-gray-800',
    icon: statusDisplay.icon,
  }
}

export function getRdvModalTitle(commande) {
  const prestationNom = commande?.prestation?.nom?.trim()
  if (prestationNom) return `Rendez-vous — ${prestationNom}`
  return 'Rendez-vous'
}

/**
 * Libellé principal liste Commandes pour un RDV (payload existant, pas de fetch).
 * @returns {string|null}
 */
export function getRdvListPrestationLabel(commande) {
  const nom = commande?.prestation?.nom?.trim()
  return nom || null
}

export function getRdvNumeroDisplay(commande) {
  if (commande?.numero) return commande.numero
  if (commande?.id) return `RDV-${String(commande.id).toUpperCase()}`
  return '—'
}

/**
 * Référence courte commerçant (affichage modal) — ID / numéro réel inchangés.
 * @returns {string}
 */
export function getRdvNumeroShortDisplay(commande) {
  const full = getRdvNumeroDisplay(commande)
  if (!full || full === '—') return '—'
  const alnum = full.replace(/^RDV-/i, '').replace(/[^a-zA-Z0-9]/g, '')
  const tail = (alnum.slice(-4) || full.slice(-4)).toUpperCase()
  return `RDV #${tail}`
}
